import { StyleSheet } from "react-native";

const insertPinStyle = StyleSheet.create({
  textHeader: {
    marginBottom: 10,
    fontSize: 20,
    fontWeight: "700",
    color: "rgba(121, 121, 121, 1)",
  },
  textCenter: {
    textAlign: "center",
  },
  textPIN: {
    marginBottom: 10,
    fontSize: 50,
    fontWeight: "700",
    color: "black",
  },
  textNote: {
    marginBottom: 10,
    fontSize: 15,
    fontWeight: "700",
    color: "rgba(121, 121, 121, 1)",
    fontStyle: "italic",
  },
});

export default insertPinStyle;
